export default __webpack_public_path__ + "src/images/packages/lush-private-game-lodge/9948fa06b1c25c3d18a3f11c4050e056-5.jpg";